import * as React from 'react';
import * as Redux from 'redux';
import { IErrorType, IResults } from '../../state-helpers/search-results';
import { clearErrorText } from '../../actions/index';
import { IState } from '../../reducers/index'


export interface IErrorProps {
    results: IResults;
    dispatch: Redux.Dispatch<IState>;
}


export class Error extends React.Component<IErrorProps, any> {

    clearErrorClick() {
        this.props.dispatch(clearErrorText(this.props.results));
    }

    render() {
        let boundClick = this.clearErrorClick.bind(this);
        return (
            <div className="adage-block-inner alert-message-search">
                <div className="alert-message-search-container alert-message-search-error" role="dialog">
                    <div className="alert-message-search-content">
                        {
                            this.props.results.errorType === IErrorType.GENERAL
                                ? <h4 className="alert-message-search-content-text" dangerouslySetInnerHTML={{ __html: "We're having trouble connecting. Please try again later." }} />
                                : null
                        }
                        {
                            this.props.results.errorType === IErrorType.TIME_OUT
                                ? <h4 className="alert-message-search-content-text" dangerouslySetInnerHTML={{ __html: "Your search took longer than expected. Please try again later." }} />
                                : null
                        }
                    </div>

                    <div className="alert-message-search-close" onClick={boundClick}>
                        <h4>&nbsp;&nbsp;<u>Dismiss</u></h4>
                    </div>
                </div>
            </div>
        );
    }
}